<template>
  <div class="report-list-container">
    <h4 class="title">
      <md-icon name="arrow-left" size="lg" class="icon" @click="back"></md-icon>
      <span>查询列表</span>
    </h4>
    <div class="content" v-if="reports && reports.length">
      <div class="report-item" v-for="(report, index) in reports" :key="index" @click="goToReportDetail(report)">
        <div class="report-detail">
          <div class="report-content">
            <div class="name">{{report.name}}</div>
            <div class="time">{{report.createTime}}</div>
          </div>
          <div class="icon-right" v-if="report.status === 1">
            <md-icon name="arrow-right" size="lg"></md-icon>
          </div>
          <div class="icon-right" v-else>
            <md-icon name="spinner" size="lg"></md-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="no-result-content" v-else>
      <loading v-if="loading"></loading>
      <md-result-page v-else type="lost" text="报告列表为空" subtext="您的名下目前没有报告" />
    </div>
  </div>
</template>
<script>
import { getReportList } from '@/services/ReportService'
import Loading from '@/components/Loading'

export default {
  components: {
    Loading
  },
  data() {
    return {
      pageSize: 50,
      reports: [],
      loading: false
    }
  },
  mounted() {
    this._fetchReportList(this.pageSize)
  },
  methods: {
    goToReportDetail(report) {
      if (report.status === 1) {
        this.$router.push({
          name: 'ReportDetail',
          query: {
            orderId: report.orderId
          }
        })
      } else {
        this.$toast({
          icon: 'warn',
          content: '正在生成报告，请稍后重试'
        })
      }
    },
    back() {
      this.$router.back()
    },
    async _fetchReportList(pageSize) {
      this.loading = true
      const openId = localStorage.getItem('openId')
      const response = await getReportList({
        openId,
        pageSize,
        pageNum: 1
      })
      this.reports = response.data
      this.loading = false
    }
  }
}
</script>
<style scoped lang="stylus">
.report-list-container {
  background: #efeff4;
  min-height: 100vh;

  .title {
    font-size: 40px;
    line-height: 80px;
    text-align: center;
    position: fixed;
    left: 0;
    right: 0;
    background: #fff;
    border-bottom: 1px solid #eee;
    z-index: 1;

    .icon {
      line-height: 80px;
      position: absolute;
      left: 20px;
    }
  }

  .content {
    background: #efeff4;
    padding: 80px 0 0;
    min-height: 100vh;
    z-index: 0;

    .report-item {
      padding: 20px 40px 0;
      background: #fff;

      &:last-child {
        .report-detail {
          border-bottom: none;
        }
      }

      .report-detail {
        padding-bottom: 20px;
        border-bottom: 1px solid #efefef;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .report-content {
          .name {
            font-size: 30px;
          }

          .time {
            font-size: 24px;
            margin-top: 8px;
          }
        }

        .icon-right {
          z-index: 0;
        }
      }
    }
  }

  .no-result-content {
    background: #fff;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
